import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AutoComplete } from 'primeng/autocomplete';
import { Searchservice } from 'src/app/service/searchservice';
import { IQueryFormat } from '../../enums/types';
import { IMainCategories_P } from '../../interfaces/IMainCategories';
import { MainCategoriesService } from '../../service/main-categories.service';
import { SelectedBrandModelService } from '../../service/selected-brand-model.service';

@Component({
    selector: 'app-auto-search',
    imports: [AutoComplete, ReactiveFormsModule],
    templateUrl: './auto-search.html',
    standalone: true,
    styleUrl: './auto-search.scss'
})
export class AutoSearch implements OnInit, AfterViewInit {
    searchForm!: FormGroup;
    filteredCountries = [];

    constructor(
        private fb: FormBuilder,
        private search: Searchservice,
        private router: Router,
        private cd: ChangeDetectorRef,
        private mainCategoriesService: MainCategoriesService,
        private selectedBrandModelService: SelectedBrandModelService
    ) {
    }

    async ngOnInit() {
        this.searchForm = this.fb.group({
            selectedCountry: ['']
        });
    }

    ngAfterViewInit() {
        // const hoverPointer = document.getElementById('hoverPointer');
        // const autoSearch = document.querySelector('app-auto-search');
        //
        // if (autoSearch && hoverPointer) {
        //     autoSearch.addEventListener('mouseenter', () => {
        //         hoverPointer.style.display = 'none';
        //         document.body.style.cursor = 'auto';
        //     });
        //
        //     autoSearch.addEventListener('mouseleave', () => {
        //         hoverPointer.style.display = 'block';
        //         document.body.style.cursor = 'none';
        //     });
        // }
    }

    async searchForResults(event: any) {
        if (event.query.length > 1) {
            const data = await this.search.searchQuery({
                searchStr: event.query
            });

            this.filteredCountries = [];

            if (data && data.length) {
                this.filteredCountries = data.map((item: any) => ({
                    _id: item._id,
                    name: item.name
                }));
            }
            this.cd.detectChanges();
        }
    }

    async searchData() {
        if (!this.searchForm.getRawValue().selectedCountry) return;
        const data = await this.search.searchQuery({
            searchStr: this.searchForm.getRawValue().selectedCountry
        });
        let resp = data.filter((value: any) => value);
        if (resp && resp.length) {
            let queryParmaObj = <any>{};
            if (resp[0].tagName === 'model') {
                queryParmaObj.modelId = resp[0]?._id;
                queryParmaObj.brandId = resp[0]?.swm_brand_id;
                queryParmaObj.modelName = resp[0]?.swm_name_str;
                queryParmaObj.mainCategoryId = await this.getMainCategoryId();
                this.selectedBrandModelService.set({
                    brandId: queryParmaObj.brandId,
                    modelId: queryParmaObj.modelId,
                    modelName: queryParmaObj.modelName
                });
            }

            if (resp[0].tagName === 'brand') {
                queryParmaObj.brandId = resp[0]?._id;
                queryParmaObj.mainCategoryId = await this.getMainCategoryId();
            }

            if (resp[0].tagName === 'product') {
                queryParmaObj.brandId = resp[0]?.pro_brand_id;
                queryParmaObj.modelId = resp[0]?.pro_model_id;
                queryParmaObj.mainCategoryId = resp[0]?.pro_main_category_id;
                queryParmaObj.subCategoryId = resp[0]?.pro_sub_category_id;
                queryParmaObj.categoryName = resp[0]?.pro_category_id.cat_name_str;
            }

            if (resp[0].tagName === 'main_category') {
                queryParmaObj.mainCategoryId = resp[0]?._id;
            }

            if (resp[0].tagName === 'sub_category') {
                queryParmaObj.mainCategoryId = resp[0]?.ssc_main_category_id;
                queryParmaObj.subCategoryId = resp[0]?._id;
            }

            if (resp[0].tagName === 'category') {
                queryParmaObj.mainCategoryId = resp[0]?.cat_main_category_id;
                queryParmaObj.subCategoryId = resp[0]?.cat_sub_category_id;
                queryParmaObj.categoryName = resp[0]?.cat_name_str;
            }

            this.router.navigate(['/phone-cases'], {
                queryParams: queryParmaObj
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    async getMainCategoryId() {
        let query: IQueryFormat = {
            find: <IMainCategories_P>{
                active: true,
                smc_name_str: <any>{
                    $regex: 'Phone Cases',
                    $options: "i"
                },
            }
        };
        let res = await this.mainCategoriesService.query(query);
        return res[0]._id || res._id;
    }
}
